"use strict";

class PropertyCommissionApprovalController {

    constructor($window, $http, SSHttpService, SSUtilService, SSAlertService, SSConfigService, SSUserService, SSConfirmationService, $timeout) {
        const self = this;

        self.$window = $window;
        self.$timeout = $timeout;
        self.$http = $http;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        self.SALE_STATUS_ABORTED = SHOWSUITE.SALE_STATUS_ABORTED;

        self.VALUE_TYPE_AMOUNT = SHOWSUITE.VALUE_TYPE_AMOUNT;
        self.VALUE_TYPE_PERCENTAGE = SHOWSUITE.VALUE_TYPE_PERCENTAGE;

        self.SALE_COMMISSION_STATUS_PENDING = SHOWSUITE.SALE_COMMISSION_STATUS_PENDING;
        self.SALE_COMMISSION_STATUS_SUBMITTED = SHOWSUITE.SALE_COMMISSION_STATUS_SUBMITTED;
        self.SALE_COMMISSION_STATUS_APPROVED = SHOWSUITE.SALE_COMMISSION_STATUS_APPROVED;
        self.SALE_COMMISSION_STATUS_REJECTED = SHOWSUITE.SALE_COMMISSION_STATUS_REJECTED;

        self.COMMISSION_TYPE_APPOINTED_AGENCY = SHOWSUITE.COMMISSION_TYPE_APPOINTED_AGENCY;
        self.COMMISSION_TYPE_NON_APPOINTED_AGENCY = SHOWSUITE.COMMISSION_TYPE_NON_APPOINTED_AGENCY;
        self.COMMISSION_TYPE_STAFF_REFERRAL = SHOWSUITE.COMMISSION_TYPE_STAFF_REFERRAL;
        self.COMMISSION_TYPE_THIRD_PARTY_REFERRAL = SHOWSUITE.COMMISSION_TYPE_THIRD_PARTY_REFERRAL;
        self.COMMISSION_TYPE_SALE_CONSULTANTS = SHOWSUITE.COMMISSION_TYPE_SALE_CONSULTANTS;
        self.COMMISSION_TYPE_TELE_SALE = SHOWSUITE.COMMISSION_TYPE_TELE_SALE;
        self.COMMISSION_TYPE_MARKETING_SERVICE_FEE = SHOWSUITE.COMMISSION_TYPE_MARKETING_SERVICE_FEE;
        self.COMMISSION_TYPE_POOL = SHOWSUITE.COMMISSION_TYPE_POOL;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        const self = this;

        self.offset = 0;
        self.limit = 100;

        self.properties = [];

        // NOTE: Order of function calls is very important in this controller
        // So be careful while making any changes to file
        self.developer_profile = self.SSUserService.getUser();
        self.prepareSaleCommissionTypes();
        
        // We need 'currentUserLevel' info to set default 'status' filter
        // So call 'getSaleCommissions()' in 'getDeveloperSettings()' 
        // self.getSaleCommissions();
        self.getDeveloperSettings();

        self.getAllProperties();
    }

    getDeveloperSettings() {
        const self = this;

        let url = 'sec/developer/settings';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.developer_settings){

                self.commission_settings = self.getSetting(response.data.developer_settings, 'commission_report_approval');
                // Prepare commission levels
                if(self.commission_settings && self.commission_settings.value){
                    self.commission_approval_levels = self.commission_settings.value.levels;
                }
                else{
                    // Set default empty level
                    self.commission_approval_levels.push({level: 0, user_ids: []});
                }

                self.commission_approval_levels_master = angular.copy(self.commission_approval_levels);
            }

            self.currentUserLevel = self.getCurrentUserLevel();
            self.prepareSaleCommissionStatuses();

            // Set 'status' according to current users level before fetching sale commissions 
            self.filters = {};
            self.filters.status =  self.getDefaultStatusFilter();

            self.getSaleCommissions();
        });
    }

    getCurrentUserLevel(){
        const self = this;

        let userLevel = 0;

        $.each(self.commission_approval_levels, function(index, obj){
            if(obj.user_ids && $.inArray(self.developer_profile.id.toString(), obj.user_ids) > -1){
                userLevel = obj.level;
            }
        });

        return userLevel;
    }

    isEnabled(sale_commission){
        const self = this;

        if(!sale_commission){
            return false;
        }

        // If 'approval_stage' is null then set it to zero
        sale_commission.approval_stage = sale_commission.approval_stage ? sale_commission.approval_stage : 0;

        // If user level is zero and status is null/pending then this user can take action
        if(sale_commission.status != self.SALE_COMMISSION_STATUS_APPROVED
            && sale_commission.approval_stage == self.currentUserLevel){
            return true;
        }
    }

    getSetting(settings, setting_name){
        const self = this;

        if(!(settings || setting_name)){
            return null;
        }

        let setting = {};

        try{
            setting = settings.find(x => x.name == setting_name);

            if(setting && setting.value){
                if(typeof setting.value == "string"){
                    setting.value = JSON.parse(setting.value);
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        return setting;
    }

    getSaleCommissionStatus(sale_commission){
        const self = this;

        if(!(self.commission_approval_levels && sale_commission)){
            return;
        }

        // (Following mechanism will be applied to get status label)
        // SALE_COMMISSION_STATUS_PENDING = 10; Pending

        // SALE_COMMISSION_STATUS_SUBMITTED = 20;
        // if stage 0 then submitted else show stage appended, e.g pending level (1 or 2, x) approval

        // SALE_COMMISSION_STATUS_APPROVED = 30;  Certified for payment
        // SALE_COMMISSION_STATUS_REJECTED = 40;  Rejected

        let STATUS = { name: 'Pending', class: 'text-warning'};

        if(sale_commission.status == self.SALE_COMMISSION_STATUS_SUBMITTED){
            // Update the name, class will be same
            STATUS.name = 'Pending Level '+ sale_commission.approval_stage +' Approval';
        }
        else{
            let _status = self.SALE_COMMISION_STATUSES.find(x => x.id == sale_commission.status);

            if(_status){
                STATUS = _status;
            }
        }

        return STATUS;
    }

    getSaleHistoryStatus(_status, approval_stage){
        const self = this;

        let STATUS = "Pending";

        if(!_status){
            return STATUS;
        }

        if(_status == self.SALE_COMMISSION_STATUS_SUBMITTED){
            STATUS = approval_stage ? ('Pending Level '+ approval_stage +' Approval') : 'Pending'; 
        }
        else if(_status == self.SALE_COMMISSION_STATUS_APPROVED){
            STATUS =  'Certified For Payment'; 
        }
        else if(_status == self.SALE_COMMISSION_STATUS_REJECTED){
            STATUS =  'Rejected'; 
        }

        return STATUS;
    }

    getSaleCommissions(){
        const self = this;

        self.selectAll = false;
        self.sale_commissions = [];
        self.invalid_commissions = [];

        let url = 'sec/developer/sales/commissions';
        let params = {
            offset: self.offset,
            limit: self.limit,
            send_total_count: 1,
            property_id: self.filters.property_id,
            status: self.filters.status ? self.filters.status.id : null,
            approval_stage: (self.filters.status && self.filters.status.level) ? self.filters.status.level : null,
            commission_type: self.filters.commission_type,
            otp_no: self.filters.otp_no,
            include: 'sales, properties, units, stacks, agencies, commission_history, users',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if(response.data && response.data.sale_commissions){
                self.sale_commissions = response.data.sale_commissions;
                self.users = response.data.users;
                self.prepareCommissionsData(response.data);
            }
        });
    }

    prepareCommissionsData(data){
        const self = this;

        self.commission_approval = {};

        if(!self.sale_commissions){
            return;
        }

        $.each(self.sale_commissions, function(index, commission){
            try{
                if(commission.commission_amount_type == self.VALUE_TYPE_AMOUNT){
                    commission.amount = commission.commission_amount_value;
                }

                if(data.sales){
                    let sale = data.sales.find(x => x.id == commission.sale_id);
                    if(sale){
                        commission.otp_no = sale.otp_no;
                        commission.exercise_date = sale.exercise_date;

                        // commission_amount_type is percentage then calculate it
                        if(commission.commission_amount_type == self.VALUE_TYPE_PERCENTAGE){
                            commission.amount = (sale.price * commission.commission_amount_value) / 100;
                        }

                        // Get unit number
                        let unit = data.units ? data.units.find(x => x.id == sale.unit_id) : null;
                        if(unit){
                            commission.unit_no = unit.named_id;

                            // Get property to display its name
                            if(data.properties){
                                let property = data.properties.find(x => x.id == unit.property_id);
                                if(property){
                                    commission.project = property.name;
                                }
                                else{
                                    commission.project = '--';
                                }
                            }
                        }
                        else{
                            commission.unit_no = '--';
                        }
                    }
                }
            }
            catch(ex){
                console.log(ex);
            }
        });
    }

    onProceedCommissionApproval(){
        const self = this;

        self.SSAlertService.clear();

        if(!self.isValidCommissionInput()){
            return;
        }

        self.commission_approval.remarks = null;

        $('#saleCommissionApprovalModal').modal('show');
    }

    isValidCommissionInput(){
        const self = this;

        let isValid = false;

        self.sale_commission_ids = [];
        self.invalid_commissions = [];

        $.each(self.commission_approval.ids, function(id, obj){

            // User can take action only for records 
            // which have 'approval_stage == currentUserLevel' and 'status != approved'
            let commission = self.sale_commissions.find(x => x.id == id);

            // If checked then 'obj' will be 'true'
            if(obj && commission){
                commission.approval_stage = commission.approval_stage? commission.approval_stage : 0;
                if(commission.approval_stage == self.currentUserLevel && commission.status != self.SALE_COMMISSION_STATUS_APPROVED){
                    self.sale_commission_ids.push(id);
                }
                else{
                    self.invalid_commissions[id] = true;
                    self.SSAlertService.warning("Warning!", "Please select valid commissions to proceed");
                }
                
                return;
            }
        });

        if(self.sale_commission_ids.length == 0){
            self.SSAlertService.warning("Warning!", "Please select valid commissions to proceed");
        }

        if(self.invalid_commissions.length == 0 && self.sale_commission_ids.length > 0){
            isValid = true;
        }

        return isValid;
    }

    proceedCommissionApproval(status){
        const self = this;

        if(self.sale_commission_ids.length == 0){
            self.SSAlertService.warning("Warning!", "Please select valid commissions to proceed");
            return;
        }

        let url = 'sec/developer/sales/commissions/approve';
        let params = {
            sale_commission_ids: self.sale_commission_ids.join(','),
            status: status,
            remarks: self.commission_approval.remarks,
        };

        loading(true);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            loading(false);
            self.hideModals();

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.SSAlertService.success("Success!", "Data updated successfully");
            self.getSaleCommissions();
        });
    }

    getAllProperties() {
        const self = this;

        let url = 'sec/developer/properties/';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.properties = response.data.properties;
        });
    }

    prepareSaleCommissionStatuses(){
        const self = this;

        self.SALE_COMMISION_STATUSES = [];
        self.SALE_COMMISION_STATUSES.push({key: self.SALE_COMMISSION_STATUS_PENDING.toString() +"_Pending", id: self.SALE_COMMISSION_STATUS_PENDING, name: 'Pending', class: 'text-warning'});
            
        $.each(self.commission_approval_levels, function(index, obj){
            if(obj.level > 0){
                let label = 'Pending Level '+ obj.level +' Approval';
                let key = self.SALE_COMMISSION_STATUS_SUBMITTED.toString() +"_"+ label;
                self.SALE_COMMISION_STATUSES.push(
                        {key: key, id: self.SALE_COMMISSION_STATUS_SUBMITTED, name: label, class: 'text-warning', level: obj.level}
                    );
            }
        });
        
        self.SALE_COMMISION_STATUSES.push({key: self.SALE_COMMISSION_STATUS_PENDING.toString() +"_Certified For Payment", id: self.SALE_COMMISSION_STATUS_APPROVED, name: 'Certified For Payment', class: 'text-success'});
        self.SALE_COMMISION_STATUSES.push({key: self.SALE_COMMISSION_STATUS_PENDING.toString() +"_Rejected", id: self.SALE_COMMISSION_STATUS_REJECTED, name: 'Rejected', class: 'text-danger'});
    }

    prepareSaleCommissionTypes(){
        const self = this;

        self.SALE_COMMISION_TYPES = [
            {id: self.COMMISSION_TYPE_APPOINTED_AGENCY, name: 'Appointed Agency'},
            {id: self.COMMISSION_TYPE_NON_APPOINTED_AGENCY, name: 'Non Appointed Agency'},
            {id: self.COMMISSION_TYPE_STAFF_REFERRAL, name: 'Staff Referral'},
            {id: self.COMMISSION_TYPE_THIRD_PARTY_REFERRAL, name: 'Third Party Referral'},
            {id: self.COMMISSION_TYPE_SALE_CONSULTANTS, name: 'Sales Consultants'},
            {id: self.COMMISSION_TYPE_TELE_SALE, name: 'Tele Sale'},
            {id: self.COMMISSION_TYPE_MARKETING_SERVICE_FEE, name: 'Marketing Service Fee'},
            {id: self.COMMISSION_TYPE_POOL, name: 'Pool'}
        ];
    }

    resetFilters(){
        const self = this;

        self.filters = {};
        self.filters.status = self.getDefaultStatusFilter();

        self.getSaleCommissions();
    }

    getDefaultStatusFilter(){
        const self = this;

        let key = self.SALE_COMMISSION_STATUS_PENDING.toString() +"_Pending";

        if (self.currentUserLevel) {
            key = self.SALE_COMMISSION_STATUS_SUBMITTED.toString() +'_Pending Level '+ self.currentUserLevel +' Approval';
        }

        return self.SALE_COMMISION_STATUSES.find(x => x.key == key);
    }

    viewHistory(sale_commission){
        const self = this;

        if(!sale_commission){
            return;
        }

        self.commission_history = sale_commission.commission_history;

        $("#saleCommissionHistoryModal").modal('show');
    }

    generatePdf(){
        const self = this;

        self.invalid_commissions = [];

        let ids = [];
        $.each(self.commission_approval.ids, function(id, obj){
            // If checked then 'obj' will be 'true'
            if(obj){
                ids.push(id);
                return;
            }
        });

        if(ids.length == 0){
            self.SSAlertService.warning("Warning!", "Please select valid commissions to proceed");
            return;
        }

        let url = 'sec/developer/sales/commissions/generatePdf';

        loading(true);
        let pdfUrl = self.SSHttpService.getApiURL(url +'?sale_commission_ids='+ ids.join(','));
        self.$window.open(pdfUrl, '_blank');
        self.SSAlertService.success('PDF generated successfully.');
        loading(false);
    }

    getUserName(user_id){
        const self = this;

        let name = "--";

        if(!user_id){
            return name;
        }

        let user = self.users.find(x => x.id == user_id);
        if(user){
            name = self.SSUserService.getDisplayName(user);
        }

        return name;
    }

    toggleSelectAll() {
        const self = this;

        if(!self.commission_approval){
            self.commission_approval = {};
        }

        self.commission_approval.ids = [];

        if(self.selectAll){
            $.each(self.sale_commissions, function (index, item) {
                // if(self.isEnabled(item)){
                //     self.commission_approval.ids[item.id] = true;
                // }
                self.commission_approval.ids[item.id] = true;
            });
        }
    }

    hideModals() {
        const self = this;

        if ($('#saleCommissionApprovalModal').is(':visible')) $('#saleCommissionApprovalModal').modal('hide');
        if ($('#saleCommissionHistoryModal').is(':visible')) $('#saleCommissionHistoryModal').modal('hide');
    }
}

PropertyCommissionApprovalController.$inject = ['$window', '$http', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSConfigService', 'SSUserService', 'SSConfirmationService', '$timeout'];
app.controller('PropertyCommissionApprovalController', PropertyCommissionApprovalController);

